/// <reference path="../walkinManagerKiosk.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManagerKiosk.ClientSelection {
  class ClientSelectionModalController {

    static $inject = ["$mdDialog", "choices", "phoneNumber", "$translate", "$filter"];

    constructor(private $mdDialog: angular.material.IDialogService,
        private choices: any,
        private phoneNumber: any,
        private $translate: angular.translate.ITranslateService,
        private $filter: angular.IFilterService) {
       
    }
    public message: any;
    getMultipleResultsText = () => {
        let phoneNumber = this.$filter('meevoPhoneNumber') as any;
        return this.$translate.instant('LABEL_YOUR_NUMBER') + ' ' + phoneNumber(this.phoneNumber) + ' ' + this.$translate.instant('LABEL_RETURNED_MULTIPLE_RESULTS_PLEASE_SELECT_THE');
    }
    selectResult = (selection: any): void => {
      this.$mdDialog.hide(selection);
    }

    close = (): void => {
      this.$mdDialog.hide();
    }
  }

  angular.module("meevo.plugins.walkinManagerKiosk")
    .controller("meevo.plugins.walkinManagerKiosk.clientSelection.ClientSelectionModalController", ClientSelectionModalController);
}